import { daysOfWeek, mealTimes } from "../components/MenuPlan/utils";
import { validateAndUseSchema } from "../utils/schema/schemaValidator";

/**
 * Schema for a recipe reference within a shopping list item
 */
const recipeReferenceSchema = {
  title: {
    required: true,
    type: "string",
    minLength: 1,
    maxLength: 200,
  },
  day: {
    required: false,
    type: "string",
    validate: (value) => {
      const validDays = daysOfWeek;
      return value && !validDays.includes(value) ? "Invalid day of week" : null;
    },
  },
  meal: {
    required: false,
    type: "string",
    validate: (value) => {
      const validMeals = mealTimes;
      return value && !validMeals.includes(value) ? "Invalid meal type" : null;
    },
  },
};

/**
 * Schema for a shopping list item
 */
export const shoppingListItemSchema = {
  name: {
    required: true,
    type: "string",
    minLength: 1,
    maxLength: 200,
  },
  quantity: {
    required: true,
    type: "number",
  },
  unit: {
    required: true,
    type: "string",
    maxLength: 30,
  },
  notes: {
    required: false,
    type: "string",
    maxLength: 500,
  },
  // This is not required as sanatize will add empty array,
  // but if no array is added, the app will throw.
  recipes: {
    required: false,
    type: "array",
    itemSchema: recipeReferenceSchema,
  },
  purchased: {
    required: false,
    type: "boolean",
    default: false,
  },
};

export default validateAndUseSchema(shoppingListItemSchema, "shoppingListItemSchema");
